var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4117 10.0762C18.4117 12.5237 16.4493 14.4862 14 14.4862C11.5516 14.4862 9.58838 12.5237 9.58838 10.0762C9.58838 7.62868 11.5516 5.66699 14 5.66699C16.4493 5.66699 18.4117 7.62868 18.4117 10.0762ZM14 22.3337C10.3854 22.3337 7.33337 21.7462 7.33337 19.4795C7.33337 17.212 10.4045 16.6453 14 16.6453C17.6156 16.6453 20.6667 17.2328 20.6667 19.4995C20.6667 21.767 17.5956 22.3337 14 22.3337Z",
    fill: "#292929",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/user_logo.756d1ffa57c3673562d45497e2945072.svg";
export { ForwardRef as ReactComponent };